import React from 'react';

const FlagAnswer = ({answer, onNewGame}) => (
  <div>
    Correct guess: {answer}
    <button className="btn" onClick={onNewGame}>
      Next
    </button>
  </div>
);

export default FlagAnswer;



// WEBPACK FOOTER //
// ./src/FlagAnswer.jsx